import React from "react";
import { ScrollTopButton, Spacer, Text } from "#ui";
import { useTranslation } from "#hooks";
import { GeneralPageLayout } from "#components";

export const Note: React.FC = () => {
  const { t } = useTranslation("note");

  return (
    <GeneralPageLayout>
      <Text text={t("text")} />
      <Spacer size={50} page={"interview"} />
      <ScrollTopButton />
      <Spacer size={20} page={"interview"} />
    </GeneralPageLayout>
  );
};
